export default function MasonryGrid({ children, className = "" }) {
  return (
    <div data-testid="masonry-grid" className={`columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-6 ${className}`}>
      {children}
    </div>
  );
}
